import apiClient from '@shared/lib/general/apiClient';
import {
  LEAD_DETAIL_CHANGE_VALUE,
  LEAD_DETAIL_SET,
} from '@/store/constants/mutationTypes';

const actions = {
  changeLeadDetailValue({ commit }, payload) {
    const {
      field,
      value,
    } = payload;
    commit({
      type: LEAD_DETAIL_CHANGE_VALUE,
      field,
      value,
    });
  },
  async getLeadDetailForPdf({ commit }, payload) {
    const {
      noticeId,
      status,
    } = payload;

    commit({
      type: LEAD_DETAIL_CHANGE_VALUE,
      field: 'loading',
      value: true,
    });

    try {
      let url = `/alertnotice/detail/id/${noticeId}`;
      if (status) {
        url = `/alertnotice/detail/id/${noticeId}?status=${status}`;
      }
      const { data } = await apiClient({
        method: 'GET',
        url,
      });
      const { data: pastAlerts } = await apiClient({
        method: 'GET',
        url: `/alerts/uid/${data.alertNotice.uid}/history`,
      });
      commit({
        type: LEAD_DETAIL_SET,
        lead: data.alertNotice,
        cycles: data.cycles,
        customer: data.alertNotice.deviceProfile.customer,
        hvac: data.alertNotice.deviceProfile,
        alert: data.alertNotice.alerts[0],
        pastAlerts,
        activeAlertList: data.leadAlerts,
        address: data.alertNotice.deviceProfile.serviceAddress,
        loading: false,
      });
    } catch (err) {
      console.error(err);
    }
  },
};

export default actions;
